import { TypeIdSchema, webhookEndpoint, webhookEndpointAccountTarget } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';
import { ProviderSchema } from '../../common/provider.schema';
import { StringEnum } from '../../utils/typebox';
import { EventTypeSchema, type EventType } from '../event/event.schema';

export const WebhookEndpointSchema = createSelectSchema(webhookEndpoint, { trigger_events: Type.Array(EventTypeSchema) });

export const InsertWebhookEndpointSchema = createInsertSchema(webhookEndpoint, { trigger_events: Type.Array(EventTypeSchema) });

export const WebhookEndpointAccountTargetSchema = createSelectSchema(webhookEndpointAccountTarget, {
  account_provider: ProviderSchema,
});

export const PublicWebhookEndpointAccountTargetSchema = Type.Composite([
  Type.Omit(WebhookEndpointAccountTargetSchema, ['endpoint_id', 'account_id', 'account_public_id']),
  Type.Object({
    object: Type.Literal('WebhookEndpointAccountTarget'),
    id: TypeIdSchema('account'),
    status: StringEnum(['active', 'deleted']),
  }),
]);

export const PublicWebhookEndpointSchema = Type.Composite([
  Type.Omit(WebhookEndpointSchema, ['id', 'public_id', 'application_id']),
  Type.Object({
    object: Type.Literal('WebhookEndpoint'),
    id: TypeIdSchema('webhookEndpoint'),
    application_id: TypeIdSchema('app'),
    account_ids: Type.Array(TypeIdSchema('account')),
    account_targets: Type.Array(PublicWebhookEndpointAccountTargetSchema),
  }),
]);

export type WebhookEndpoint = typeof webhookEndpoint.$inferSelect;
export type InsertWebhookEndpoint = typeof webhookEndpoint.$inferInsert;
export type WebhookEndpointAccountTarget = typeof webhookEndpointAccountTarget.$inferSelect;
export type InsertWebhookEndpointAccountTarget = typeof webhookEndpointAccountTarget.$inferInsert;
export type PublicWebhookEndpoint = Static<typeof PublicWebhookEndpointSchema>;
export type PublicWebhookEndpointAccountTarget = Static<typeof PublicWebhookEndpointAccountTargetSchema>;
export type WebhookTriggerEvent = EventType;
